import React, { useState } from 'react';
import { ContactCallHistory } from '../ContactCallHistory';
import { ActivityTableHeader } from './ActivityTableHeader';
import { useContactCallsGQL } from '../../../../hooks/graphql/contacts/useContactCallsGQL';
import { useOrganizationStore } from '../../../../stores/useOrganizationStore';
import { handleDateRangeChange as convertDateRange } from '../../../../utils/dateRangeTimezone';
import { isPreviewContactId, PREVIEW_CALLS } from '../../../../pages/previewMockData';

interface CallsTabProps {
  contactId: string;
  contactFirstName?: string;
}

export const CallsTab: React.FC<CallsTabProps> = ({
  contactId,
  contactFirstName,
}) => {
  const { organization } = useOrganizationStore();
  const [dateRange, setDateRange] = useState<{ from: Date | null; to: Date | null }>({
    from: null,
    to: null,
  });

  const isPreview = isPreviewContactId(contactId);
  const live = useContactCallsGQL(isPreview ? '' : contactId, dateRange);
  const calls = isPreview ? PREVIEW_CALLS : live.calls;
  const total = isPreview ? PREVIEW_CALLS.length : live.total;
  const loading = isPreview ? false : live.loading;
  const resetPage = live.resetPage;

  const handleDateRangeChange = (range: { from: Date | null; to: Date | null }) => {
    const { dateRange: converted } = convertDateRange(range, organization?.timezone);
    setDateRange(converted);
    resetPage();
  };

  return (
    <div className="flex flex-col h-full min-h-0 gap-4">
      <ActivityTableHeader
        title="Call History"
        dateRange={dateRange}
        onDateRangeChange={handleDateRangeChange}
        count={total}
        isLoading={loading}
      />

      <ContactCallHistory
        contactId={contactId}
        contactFirstName={contactFirstName}
        gqlCalls={calls}
        serverPagination={{
          hasNext: isPreview ? false : live.hasNext,
          onNextPage: live.handleNextPage,
          isLoading: loading,
          ...(isPreview
            ? {}
            : {
                currentPage: live.currentPage,
                total: live.total,
                pageSize: live.pageSize,
                onPrevPage: live.handlePrevPage,
                onPageChange: live.goToPage,
              }),
        }}
      />
    </div>
  );
};
